module.exports = __webpack_public_path__ + "img/header-weddingRingsExclusive.3e18d4d.webp";